import { format } from 'date-fns-tz';
import queryString from 'qs';

export const getBrandListRequest = (yearMonth) => {
  const queries = {
    yearMonth: format(yearMonth, 'yyyy-MM'),
  };
  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getBrandListRequest;
